module.exports = __webpack_public_path__ + "static/media/sx.89f96e78.svg";